"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5871],{

/***/ 45871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_Projects; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/Projects/Project/project.styles.tsx



const ProjectButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1mplc3e0"
})("max-width:13rem;border:none;border-radius:3.75rem;padding:0.5rem 1.8125rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";text-decoration:none;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";transition:background-color 300ms ease-in-out;text-align:center;font-size:1.25rem;line-height:2rem;letter-spacing:0.0125rem;cursor:pointer;position:relative;box-shadow:none;");
const ProjectWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1mplc3e1"
})("border-radius:0.5rem;display:flex;flex-direction:column;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";text-decoration:none;position:relative;width:100%;height:100%;max-width:23.125rem;", mixins/* boxShadow */.Wn, ";&:hover{", ProjectButton, "{background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";}}&:after{border-radius:0.5rem;box-shadow:0.5rem 0.5rem 1.5rem rgba(23,0,89,0.29);}@media (min-width:852px){margin-bottom:0;}");
const ProjectTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1mplc3e2"
})(Typography/* ParagraphL */.q9, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";line-height:2rem;font-weight:400;margin:0 0 1.5rem 0;");
const ProjectImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1mplc3e3"
})("width:100%;height:100%;max-height:16rem;img{border-top-left-radius:0.5rem;border-top-right-radius:0.5rem;max-height:16rem;width:100%;height:100%;}");
const ProjectDetails = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1mplc3e4"
})("padding:1.5rem 1.5rem 2rem 1.5rem;");
const ProjectButtonArrow = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1mplc3e5"
})("margin-left:0.625rem;");

;// CONCATENATED MODULE: ./components/sections/Projects/Project/project.utils.ts
const getCaseStudyLink = (title)=>"/case-studies/".concat(title.replace(/\s/g, "-").toLowerCase());

// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/sections/Projects/Project/Project.tsx








const Project = (param)=>{
    let { project  } = param;
    const title = prismic_reactjs.RichText.asText(project.title);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        id: title,
        href: getCaseStudyLink(title),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProjectWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectImage, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        ...(0,imageSerializer/* imageSerializer */.l)(project.image)
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProjectDetails, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectTitle, {
                            children: prismic_reactjs.RichText.asText(project.visible_title)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProjectButton, {
                            children: [
                                prismic_reactjs.RichText.asText(project.see_project),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectButtonArrow, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                        width: "22",
                                        height: "12",
                                        viewBox: "0 0 22 12",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            d: "M1.66968 6H20.1697M20.1697 6L15.1697 1M20.1697 6L15.1697 11",
                                            stroke: "white",
                                            strokeWidth: "2",
                                            strokeLinecap: "round"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, title);
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./components/sections/Projects/projects.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 7.5rem 0;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: center;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}




const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e1bwgie90"
})("display:flex;flex-direction:column;max-width:100%;background:#f4f4f4;padding:4rem 0;", mixins.mq.mobileMax((0,emotion_react_browser_esm/* css */.iv)(_templateObject())));
const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bwgie91"
})("display:flex;flex-direction:column;row-gap:2.5rem;", mixins/* defaultContainerSize */.sX, ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "e1bwgie92"
})(Typography/* Header2 */.zV, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";text-align:left;margin:0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())));
const Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1bwgie93"
})(Typography/* ParagraphS */.fw, ";margin:0;letter-spacing:0.0125rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";");
const ProjectsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bwgie94"
})("max-width:48.125rem;display:flex;flex-wrap:wrap;gap:1.875rem;", mixins.mq.mobileMax((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())));

;// CONCATENATED MODULE: ./utils/htmlSerializers/projectsHtmlSerializer.tsx




const propsWithUniqueKey = (props, key)=>Object.assign(props || {}, {
        key
    });
// TODO: type of this function
const projectsHtmlSerializer = (type, element, content, children, key)=>{
    let props = {};
    switch(type){
        case prismic_reactjs.Elements.paragraph:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                ...propsWithUniqueKey(props, key),
                children: children
            });
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./components/sections/Projects/Projects.tsx





const Projects = (param)=>{
    let { items , title , description , titleAs  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    as: titleAs,
                    children: title
                }),
                description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(prismic_reactjs.RichText, {
                    render: description,
                    htmlSerializer: projectsHtmlSerializer
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsWrapper, {
                    children: items.map((item)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Project, {
                            ...item
                        }, prismic_reactjs.RichText.asText(item.project.title)))
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/Projects/index.ts

/* harmony default export */ var sections_Projects = (Projects);


/***/ })

}]);